import { SkeletonList } from 'components/Skeleton/SkeletonList';
import { TTruckerItem } from 'context/reducers/truckers.type';
import { useAppStates } from 'hooks/useAppStates';

import React, { FC } from 'react';

import { SuggestedTruckDrivers } from '../SuggestedTruckDrivers';

export const Listing: FC<{
  truckerListData: TTruckerItem[];
}> = ({ truckerListData }) => {
  const { isLoadingPartial } = useAppStates();

  return (
    <>{isLoadingPartial ? <SkeletonList selfPadding /> : <SuggestedTruckDrivers truckerListData={truckerListData} />}</>
  );
};
